import { __decorate, __metadata } from 'tslib';
import { NotEnumerable } from '@tencent/workbench-core';
import { ParamRegistry } from '../../registries/param-registry.js';
import { ControllerRegistry } from '../../registries/controller-registry.js';
import { MiddlewareRegistry } from '../../registries/middleware-registry.js';

class HandlerMetadata {
    constructor(handler, methodKey) {
        this.handler = handler;
        this.methodKey = methodKey;
        this.handlerType = 'function';
        this.injectable = false;
        this.nextFunction = false;
        this.resolve();
    }
    resolve() {
        let target = this.handler;
        if (MiddlewareRegistry.has(this.handler)) {
            const middleware = MiddlewareRegistry.get(this.handler);
            this.handlerType = 'middleware';
            this.methodKey = 'use';
            target = middleware.useClass;
        }
        else if (ControllerRegistry.has(this.handler)) {
            this.handlerType = 'controller';
        }
        if (this.methodKey) {
            this.injectable = ParamRegistry.isInjectable(target, this.methodKey);
        }
    }
    get type() {
        return this.handlerType;
    }
    get methodName() {
        return this.methodKey;
    }
    get hasNextFunction() {
        return this.nextFunction;
    }
    get target() {
        return this.handler;
    }
    get services() {
        if (this.injectable) {
            return ParamRegistry.getParams(this.target, this.methodName);
        }
        return [];
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", String)
], HandlerMetadata.prototype, "handlerType", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], HandlerMetadata.prototype, "injectable", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], HandlerMetadata.prototype, "nextFunction", void 0);

export { HandlerMetadata };
//# sourceMappingURL=handler-metadata.js.map
